// src/utils/reportMetrics.js
// Helper DRY para calculo de metricas de relatorios semanais

const fmt = (min) =>
  `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;

/**
 * Compute display metrics for a weekly report
 * @param {Object} r - Report object from Firestore
 * @returns {Object} { totalWorked, totalLunch, totalTravel, fechamentoTotal, closingMin, lunchMin, travelMin }
 */
export function computeReportMetrics(r) {
  const totalWorked = r.weekWorkHours || r.weekTotalHours || "00:00";
  const [wH, wM] = totalWorked.split(":").map(n => parseInt(n) || 0);
  const lunchMin = Object.values(r.lunchMinDay || {}).reduce((a, b) => a + (b || 0), 0);
  const travelMin = Object.values(r.travelMinDay || {}).reduce((a, b) => a + (b || 0), 0);
  const closingMin = wH * 60 + wM + lunchMin + travelMin;

  return {
    totalWorked,
    lunchMin,
    travelMin,
    closingMin,
    totalLunch: fmt(lunchMin),
    totalTravel: fmt(travelMin),
    fechamentoTotal: fmt(closingMin)
  };
}
